import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'

import '../../TemplateMessage/GenericTemplate/TemplateMessage.css'
import { findAttributeValue, generatePostBackObject, parseAttributes } from '../../../../actions/static'
import { quickRepliesColorStylesSetter } from '../../../../helper/QuickRepliesColorStylesSetter'
import { attributeName, keyType } from '../../../../constants/string'

import { QuickReplyContainer, QuickReplyText } from './QuickReply.style'

const QuickReply = ({
  reply,
  postMessage,
  isImageLoaded,
  setIsImageLoaded,
  isLoadingIframeData,
  hasDropdown,
  messageId,
  setPassedOrSkippedFlowComponentsId,
  setSelectedValue,
  hasRating,
  setRating
}) => {
  const postBack = useMemo(() => generatePostBackObject(reply), [reply])
  const [qrColors, setQrColors] = useState({
    textColor: '',
    borderColor: '',
    backgroundColor: '',
    clickedBackgroundColor: '',
    clickedBorderColor: '',
    focusBackgroundColor: '',
    focusBorderColor: ''
  })

  useEffect(() => {
    const qrAttributeValue = findAttributeValue(parseAttributes(reply.payload), attributeName.QUICK_REPLY_TYPE)?.value || ''
    quickRepliesColorStylesSetter(qrAttributeValue, qrColors, setQrColors)
  }, [reply])

  const quickReplyClickHandler = () => {
    postMessage(postBack)
    isImageLoaded && setIsImageLoaded(false)
    if (hasDropdown || hasRating) {
      hasDropdown && setSelectedValue('')
      hasRating && setRating(-1)
      setPassedOrSkippedFlowComponentsId(messageId)
    }
  }

  const quickReplyKeyDownHandler = (e) => {
    const currentKey = e.key.toLowerCase()
    if (currentKey === keyType.ENTER) {
      e.preventDefault()
      quickReplyClickHandler()
    }
  }

  return (
    <QuickReplyContainer
      borderColor={qrColors.borderColor}
      backgroundColor={qrColors.backgroundColor}
      clickedBackgroundColor={qrColors.clickedBackgroundColor}
      clickedBorderColor={qrColors.clickedBorderColor}
      focusBackgroundColor={qrColors.focusBackgroundColor}
      focusBorderColor={qrColors.focusBorderColor}
      onClick={quickReplyClickHandler}
      onKeyDown={quickReplyKeyDownHandler}
      tabIndex={isLoadingIframeData ? -1 : 0}
    >
      <QuickReplyText textColor={qrColors.textColor}>
        {reply.title}
      </QuickReplyText>
    </QuickReplyContainer>
  )
}

QuickReply.propTypes = {
  color: PropTypes.string.isRequired,
  reply: PropTypes.shape({
    title: PropTypes.string.isRequired,
    payload: PropTypes.string.isRequired,
    content_type: PropTypes.string,
    is_filled: PropTypes.bool
  }),
  postMessage: PropTypes.func.isRequired,
}

export default QuickReply
